import { DateRangePicker } from 'app/ComponentLibrary/DateRangeNew';
import { isNullOrUndefined } from 'app/helpers/objectHelpers';
import moment from 'moment';
import React, { useEffect } from 'react';
import { Controller, useFormContext, useWatch } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { selectIsEditMod, selectIsUndoModal } from 'store/redux-store/placement-mods/selectors';
import { placementModsAction } from 'store/redux-store/placement-mods/slice';
import { makeStyles } from 'tss-react/mui';
const useStyles = makeStyles()(theme => ({
  inputFields: {
    minWidth: '326px',
    height: '53px',
    '& .css-10gjzo5.Mui-disabled': {
      height: '53px',
      '& .css-10gjzo5.Mui-disabled': {
        '-webkit-text-fill-color': '#000000d9',
      },
    },
  },
}));
export const StartDate = () => {
  const { classes } = useStyles();
  const { control, formState: { errors }, getValues, clearErrors, setError } = useFormContext();
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const startDate: any = useWatch({ name: 'startDate' });
  const dispatch = useDispatch();
  const isUndoModal = useSelector(selectIsUndoModal);
  const isModEdit = useSelector(selectIsEditMod);

  const validation = () => {
    if (getValues('startDate')) {
      clearErrors('startDate');
    } else {
      setError('startDate', {});
    }
  };

  useEffect(() => {
    validation();
    if (isUndoModal) {
      dispatch(placementModsAction.setIsUndoModal(false));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isUndoModal]);

  return (
    <Controller
      control={control}
      name={'startDate'}
      rules={{
        required: true,
      }}
      render={({ field: { onChange, value, ...rest } }) => {
        const newStartDate = moment(startDate ?? null);
        return (
          <React.Fragment>
            <DateRangePicker
              onChange={newValue => {
                if (newValue.startDate !== undefined) {
                  const newDate = moment(newValue.startDate);
                  const setTo = newDate.isValid() ? moment(newDate).format('YYYY-MM-DDTHH:mm:ss') : null;
                  onChange(setTo);
                  validation();
                } else {
                  onChange(null);
                  validation();
                }
              }}
              value={startDate}
              onCancel={() => {}}
              clear
              open={false}
              variant="filled"
              single
              placeholder="Start Date"
              useMaxWidth={true}
              showIcon={true}
              className={classes.inputFields}
              labelClass={classes.inputFields}
              actionBar={false}
              clickAway={true}
              trailingIconShow={true}
              readOnly={!isModEdit}
              required={true}
              keepClickAwayVal={true}
              initialDateRange={{
                startDate: newStartDate.isValid() ? new Date(newStartDate.format('YYYY-MM-DDTHH:mm:ss')) : undefined,
                endDate: newStartDate.isValid() ? new Date(newStartDate.format('YYYY-MM-DDTHH:mm:ss')) : undefined,
                useLabelAsValue: true,
              }}
              error={!isNullOrUndefined(errors?.startDate)}
              helperText={!isNullOrUndefined(errors?.startDate) ? errors?.startDate?.message : undefined}
            />
          </React.Fragment>
        );
      }}
    />
  );
};
